import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 md:gap-16 items-center">
          <div className="w-full lg:w-1/2">
            <div className="rounded-3xl overflow-hidden bg-background-200 h-[300px] md:h-[420px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20creative%20workspace%20with%20large%20monitor%20displaying%20digital%20art%2C%20warm%20cozy%20atmosphere%2C%20indoor%20plants%2C%20wooden%20desk%2C%20natural%20light%20from%20window%2C%20creative%20studio%20vibe%2C%20soft%20neutral%20colors%2C%20professional%20yet%20comfortable%20environment&width=800&height=600&seq=about-hero-01&orientation=landscape"
                alt="韩国漫画网"
                title="韩国漫画网 - 韩漫大全"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
              品牌故事
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mt-4 leading-tight">
              韩国漫画网<br />您身边最专业的韩漫平台
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-5 leading-relaxed">
              韩国漫画网成立于2020年，是专业的韩漫大全平台。我们拥有超过5000部韩国漫画资源，涵盖恋爱、热血、奇幻、搞笑等全题材分类。采用先进的下拉式阅读技术，让您无需翻页即可畅快阅读，享受如行云流水般的漫画体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 mt-3 leading-relaxed">
              我们坚持免费阅读的理念，所有漫画内容完全免费，每日更新不懈怠，致力于为每一位韩漫爱好者打造最优质的阅读平台。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-6 px-6 py-2.5 rounded-full border border-background-300 text-sm font-medium text-foreground-700 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-up-line text-base" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}